export default __webpack_public_path__ + "img/pin_icons/wheel_chair_b.svg";